import { mouseEvent } from "../common/mouse_event";
import BookItem from "../common/bookItem";
export default class AfileChangeBGPicStep extends BookItem {
    getAfileChangeBGPicStep = [];
    constructor(el, target) {
        super(el, target);
        this.connectNumber = this.el.connectNumber;
        this.ctrlObjStep = this.el.ctrlObjStep;

        this.picBtn;

        //測試用
    }

    init() {
        mouseEvent.add_mouse_event(this);
        this.target.visible = false;

        this.getAfileChangeBGPicStep = this.itemControl.getItemsByClassConnect("afilechangebgpicstep", this);
        
        // this.itemControl.bookItems.forEach(element => {
        //     if (element instanceof AfileChangeBGPicStep && this.connectNumber == element.connectNumber) {
        //         this.getAfileChangeBGPicStep.push(element);
        //     }
        // });
        // console.log("this.getAfileChangeBGPicStep1231231231", this.getAfileChangeBGPicStep);
    }

    trigger() {
        const self = this;

        //換底圖
        switch (self.ctrlObjStep) {
            case "上一個":
                console.log("上一個");

                //換底圖 true => 下一張, false =>上一張
                self.itemControl.loader.changeSeriesBackground(false);

                //如果是初始第一張時隱藏自己
                if (self.itemControl.loader.getCurrentSeriesIndex == 0) {
                    self.target.visible = false;
                }
                //然後打開對方
                self.getAfileChangeBGPicStep.forEach(element => {
                    if (element.ctrlObjStep == "下一個") {
                        element.target.visible = true;
                    }
                });
                break;
            case "下一個":
                console.log("下一個");
                self.itemControl.loader.changeSeriesBackground(true);
                //如果是最後一張時隱藏自己
                // console.log("!@^#%@!*&^#$!%@", this.picBtn);

                if (self.itemControl.loader.getCurrentSeriesIndex == this.picBtn.maxNum - 1) {
                    self.target.visible = false;
                }
                //打開對方
                self.getAfileChangeBGPicStep.forEach(element => {
                    if (element.ctrlObjStep == "上一個") {
                        element.target.visible = true;
                    }
                });
                break;
        }
    }

    //抓當前點的AfileChangeBGPicStep資料
    setBtn(btn) {
        this.picBtn = btn;
    }
}